module.exports = __webpack_public_path__ + "img/Custom Made.2ba665a6.jpg";